export const CHAT_SIZE_OPTIONS = {
  REGULAR: { name: "Regular (1)", value: "regular" },
  SMALL: { name: "Small (2–4)", value: "small" },
  MEDIUM: { name: "Medium (5–7)", value: "medium" },
  LARGE: { name: "Large (8–10)", value: "large" },
} as const;
